/**
 * Internal dependencies
 */
import connectionSelectors from '../components/with-connection-status/state/selectors';

const selectors = {
	...connectionSelectors,
};

export default selectors;
